import { createApiRef } from '@backstage/core-plugin-api';

export const mediaCreatorApiRef = createApiRef<MediaCreatorApi>({
  id: 'plugin.media-creator.service',
});

export interface VoiceSummary {
  id: string;
  name: string;
}

export interface MediaCreatorApi {
  generateSpeech(
    text: string,
    id: string,
    format?: string,
    stability?: number,
    languageCode?: string,
  ): Promise<Blob>;
  listVoices(): Promise<VoiceSummary[]>;
}
